import React from 'react';
import WatchReview from '../watchReview'


function HeLovesMe(props) {

        return (
            <WatchReview 
                tube="https://www.youtube.com/embed/HnjNVwor2XI" 
                blerb="Welcome to Brothers Sip and Talk Shit, where we discuss all things horror and foreign...films. Over our next drink, we discuss Romance/Thriller?, 'He Loves Me, He Loves Me Not'. This is definitely a sleeper hit...."
            />
        )
    }   

export default HeLovesMe;